/*
 * cart-address.js — Sepette Ülke → İl/Bölge → İlçe/Şehir kademeli seçici (Black Fashion Wholesale / TOPTAN)
 * --------------------------------------------------------------------------------------------------------
 * v3: 33 ülkenin TAMAMINDA bölge + şehir dropdown'ı. Bölge→şehir verisi ayrı dosyada
 *     (cart-address-data.js, ~50KB) ve yalnızca gerektiğinde yüklenir; TR gömülüdür.
 * v3.1: elle yazma KALDIRILDI — tüm seçim listeden; şehir listesi olmayan bölgede
 *       bölge adı tek seçenek olarak sunulur (veri her bölgede dolu tutulur).
 *
 * Doğrulanmış checkout eşlemesi (blackfashionwholesale.com canlı test, 2026-07-09/10):
 *   TR             : İl → city ("Şehir" alanı), İlçe → address2 ("İlçe")
 *   Shopify-il ülkesi (US,GB,ZA,ES,IT,CO,EG,NG,RO,RU):
 *                    Bölge → province (checkout eyalet listesi, ör. California→CA), Şehir → city
 *   Diğer ülkeler  : Şehir → city, Bölge → address2 (bilgi amaçlı)
 *
 * Yöntem: "Ödemeye geç"te sepet /cart/{varyant}:{adet}?checkout[...] permalink'i ile
 *         checkout'a adresli taşınır. Özel özellikli ürün veya İNDİRİMLİ sepette
 *         ön-doldurmasız /checkout'a düşülür (sepet/kupon bozulmaz).
 */
(function () {
  'use strict';

  var LS_KEY = 'bfw_cart_address_v1';

  // Dil tespiti: snippet data-ca-lang="en" basar; yedek olarak Shopify.locale / <html lang>
  var IS_EN = (function () {
    try {
      if (document.querySelector('[data-cart-address][data-ca-lang="en"]')) return true;
      if (window.Shopify && window.Shopify.locale) {
        return String(window.Shopify.locale).toLowerCase().indexOf('en') === 0;
      }
      return String(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    } catch (e) { return false; }
  })();

  // Ülke listesi: toptanın kargo bölgesi tanımlı 33 ülkesi (kaynak: /cart/shipping_rates 2026-07-06).
  // name=TR görünen ad, en=EN görünen ad (kod/checkout eşlemesi code üzerinden, ada dokunulmaz).
  var COUNTRIES = [
    { code: 'TR', name: 'Türkiye', en: 'Turkey' },
    { code: 'DE', name: 'Almanya', en: 'Germany' },
    { code: 'US', name: 'Amerika Birleşik Devletleri', en: 'United States' },
    { code: 'AL', name: 'Arnavutluk', en: 'Albania' },
    { code: 'BA', name: 'Bosna-Hersek', en: 'Bosnia and Herzegovina' },
    { code: 'BG', name: 'Bulgaristan', en: 'Bulgaria' },
    { code: 'DZ', name: 'Cezayir', en: 'Algeria' },
    { code: 'PS', name: 'Filistin', en: 'Palestine' },
    { code: 'FR', name: 'Fransa', en: 'France' },
    { code: 'ZA', name: 'Güney Afrika', en: 'South Africa' },
    { code: 'GE', name: 'Gürcistan', en: 'Georgia' },
    { code: 'NL', name: 'Hollanda', en: 'Netherlands' },
    { code: 'GB', name: 'İngiltere', en: 'United Kingdom' },
    { code: 'ES', name: 'İspanya', en: 'Spain' },
    { code: 'IL', name: 'İsrail', en: 'Israel' },
    { code: 'IT', name: 'İtalya', en: 'Italy' },
    { code: 'ME', name: 'Karadağ', en: 'Montenegro' },
    { code: 'QA', name: 'Katar', en: 'Qatar' },
    { code: 'KZ', name: 'Kazakistan', en: 'Kazakhstan' },
    { code: 'KG', name: 'Kırgızistan', en: 'Kyrgyzstan' },
    { code: 'CO', name: 'Kolombiya', en: 'Colombia' },
    { code: 'MK', name: 'Kuzey Makedonya', en: 'North Macedonia' },
    { code: 'LB', name: 'Lübnan', en: 'Lebanon' },
    { code: 'EG', name: 'Mısır', en: 'Egypt' },
    { code: 'NG', name: 'Nijerya', en: 'Nigeria' },
    { code: 'PL', name: 'Polonya', en: 'Poland' },
    { code: 'RO', name: 'Romanya', en: 'Romania' },
    { code: 'RU', name: 'Rusya', en: 'Russia' },
    { code: 'SN', name: 'Senegal', en: 'Senegal' },
    { code: 'SK', name: 'Slovakya', en: 'Slovakia' },
    { code: 'SA', name: 'Suudi Arabistan', en: 'Saudi Arabia' },
    { code: 'TN', name: 'Tunus', en: 'Tunisia' },
    { code: 'UA', name: 'Ukrayna', en: 'Ukraine' }
  ];
  function countryDisplayName(c) { return IS_EN && c.en ? c.en : c.name; }

  // Shopify'ın resmi il/eyalet listesi olan ülkeler → province parametresi gönderilir
  var PROV_CC = { US: 1, GB: 1, ZA: 1, ES: 1, IT: 1, CO: 1, EG: 1, NG: 1, RO: 1, RU: 1 };

  // 81 il → ilçeleri (TR gömülü; diğer ülkeler cart-address-data.js'ten tembel yüklenir)
  var TR = {
    'Adana': ['Aladağ','Ceyhan','Çukurova','Feke','İmamoğlu','Karaisalı','Karataş','Kozan','Pozantı','Saimbeyli','Sarıçam','Seyhan','Tufanbeyli','Yumurtalık','Yüreğir'],
    'Adıyaman': ['Besni','Çelikhan','Gerger','Gölbaşı','Kâhta','Merkez','Samsat','Sincik','Tut'],
    'Afyonkarahisar': ['Başmakçı','Bayat','Bolvadin','Çay','Çobanlar','Dazkırı','Dinar','Emirdağ','Evciler','Hocalar','İhsaniye','İscehisar','Kızılören','Merkez','Sandıklı','Sinanpaşa','Sultandağı','Şuhut'],
    'Ağrı': ['Diyadin','Doğubayazıt','Eleşkirt','Hamur','Merkez','Patnos','Taşlıçay','Tutak'],
    'Aksaray': ['Ağaçören','Eskil','Gülağaç','Güzelyurt','Merkez','Ortaköy','Sarıyahşi','Sultanhanı'],
    'Amasya': ['Göynücek','Gümüşhacıköy','Hamamözü','Merkez','Merzifon','Suluova','Taşova'],
    'Ankara': ['Akyurt','Altındağ','Ayaş','Bala','Beypazarı','Çamlıdere','Çankaya','Çubuk','Elmadağ','Etimesgut','Evren','Gölbaşı','Güdül','Haymana','Kahramankazan','Kalecik','Keçiören','Kızılcahamam','Mamak','Nallıhan','Polatlı','Pursaklar','Sincan','Şereflikoçhisar','Yenimahalle'],
    'Antalya': ['Akseki','Aksu','Alanya','Demre','Döşemealtı','Elmalı','Finike','Gazipaşa','Gündoğmuş','İbradı','Kaş','Kemer','Kepez','Konyaaltı','Korkuteli','Kumluca','Manavgat','Muratpaşa','Serik'],
    'Ardahan': ['Çıldır','Damal','Göle','Hanak','Merkez','Posof'],
    'Artvin': ['Ardanuç','Arhavi','Borçka','Hopa','Kemalpaşa','Merkez','Murgul','Şavşat','Yusufeli'],
    'Aydın': ['Bozdoğan','Buharkent','Çine','Didim','Efeler','Germencik','İncirliova','Karacasu','Karpuzlu','Koçarlı','Köşk','Kuşadası','Kuyucak','Nazilli','Söke','Sultanhisar','Yenipazar'],
    'Balıkesir': ['Altıeylül','Ayvalık','Balya','Bandırma','Bigadiç','Burhaniye','Dursunbey','Edremit','Erdek','Gömeç','Gönen','Havran','İvrindi','Karesi','Kepsut','Manyas','Marmara','Savaştepe','Sındırgı','Susurluk'],
    'Bartın': ['Amasra','Kurucaşile','Merkez','Ulus'],
    'Batman': ['Beşiri','Gercüş','Hasankeyf','Kozluk','Merkez','Sason'],
    'Bayburt': ['Aydıntepe','Demirözü','Merkez'],
    'Bilecik': ['Bozüyük','Gölpazarı','İnhisar','Merkez','Osmaneli','Pazaryeri','Söğüt','Yenipazar'],
    'Bingöl': ['Adaklı','Genç','Karlıova','Kiğı','Merkez','Solhan','Yayladere','Yedisu'],
    'Bitlis': ['Adilcevaz','Ahlat','Güroymak','Hizan','Merkez','Mutki','Tatvan'],
    'Bolu': ['Dörtdivan','Gerede','Göynük','Kıbrıscık','Mengen','Merkez','Mudurnu','Seben','Yeniçağa'],
    'Burdur': ['Ağlasun','Altınyayla','Bucak','Çavdır','Çeltikçi','Gölhisar','Karamanlı','Kemer','Merkez','Tefenni','Yeşilova'],
    'Bursa': ['Büyükorhan','Gemlik','Gürsu','Harmancık','İnegöl','İznik','Karacabey','Keles','Kestel','Mudanya','Mustafakemalpaşa','Nilüfer','Orhaneli','Orhangazi','Osmangazi','Yenişehir','Yıldırım'],
    'Çanakkale': ['Ayvacık','Bayramiç','Biga','Bozcaada','Çan','Eceabat','Ezine','Gelibolu','Gökçeada','Lapseki','Merkez','Yenice'],
    'Çankırı': ['Atkaracalar','Bayramören','Çerkeş','Eldivan','Ilgaz','Kızılırmak','Korgun','Kurşunlu','Merkez','Orta','Şabanözü','Yapraklı'],
    'Çorum': ['Alaca','Bayat','Boğazkale','Dodurga','İskilip','Kargı','Laçin','Mecitözü','Merkez','Oğuzlar','Ortaköy','Osmancık','Sungurlu','Uğurludağ'],
    'Denizli': ['Acıpayam','Babadağ','Baklan','Bekilli','Beyağaç','Bozkurt','Buldan','Çal','Çameli','Çardak','Çivril','Güney','Honaz','Kale','Merkezefendi','Pamukkale','Sarayköy','Serinhisar','Tavas'],
    'Diyarbakır': ['Bağlar','Bismil','Çermik','Çınar','Çüngüş','Dicle','Eğil','Ergani','Hani','Hazro','Kayapınar','Kocaköy','Kulp','Lice','Silvan','Sur','Yenişehir'],
    'Düzce': ['Akçakoca','Cumayeri','Çilimli','Gölyaka','Gümüşova','Kaynaşlı','Merkez','Yığılca'],
    'Edirne': ['Enez','Havsa','İpsala','Keşan','Lalapaşa','Meriç','Merkez','Süloğlu','Uzunköprü'],
    'Elazığ': ['Ağın','Alacakaya','Arıcak','Baskil','Karakoçan','Keban','Kovancılar','Maden','Merkez','Palu','Sivrice'],
    'Erzincan': ['Çayırlı','İliç','Kemah','Kemaliye','Merkez','Otlukbeli','Refahiye','Tercan','Üzümlü'],
    'Erzurum': ['Aşkale','Aziziye','Çat','Hınıs','Horasan','İspir','Karaçoban','Karayazı','Köprüköy','Narman','Oltu','Olur','Palandöken','Pasinler','Pazaryolu','Şenkaya','Tekman','Tortum','Uzundere','Yakutiye'],
    'Eskişehir': ['Alpu','Beylikova','Çifteler','Günyüzü','Han','İnönü','Mahmudiye','Mihalgazi','Mihalıççık','Odunpazarı','Sarıcakaya','Seyitgazi','Sivrihisar','Tepebaşı'],
    'Gaziantep': ['Araban','İslahiye','Karkamış','Nizip','Nurdağı','Oğuzeli','Şahinbey','Şehitkamil','Yavuzeli'],
    'Giresun': ['Alucra','Bulancak','Çamoluk','Çanakçı','Dereli','Doğankent','Espiye','Eynesil','Görele','Güce','Keşap','Merkez','Piraziz','Şebinkarahisar','Tirebolu','Yağlıdere'],
    'Gümüşhane': ['Kelkit','Köse','Kürtün','Merkez','Şiran','Torul'],
    'Hakkari': ['Çukurca','Derecik','Merkez','Şemdinli','Yüksekova'],
    'Hatay': ['Altınözü','Antakya','Arsuz','Belen','Defne','Dörtyol','Erzin','Hassa','İskenderun','Kırıkhan','Kumlu','Payas','Reyhanlı','Samandağ','Yayladağı'],
    'Iğdır': ['Aralık','Karakoyunlu','Merkez','Tuzluca'],
    'Isparta': ['Aksu','Atabey','Eğirdir','Gelendost','Gönen','Keçiborlu','Merkez','Senirkent','Sütçüler','Şarkikaraağaç','Uluborlu','Yalvaç','Yenişarbademli'],
    'İstanbul': ['Adalar','Arnavutköy','Ataşehir','Avcılar','Bağcılar','Bahçelievler','Bakırköy','Başakşehir','Bayrampaşa','Beşiktaş','Beykoz','Beylikdüzü','Beyoğlu','Büyükçekmece','Çatalca','Çekmeköy','Esenler','Esenyurt','Eyüpsultan','Fatih','Gaziosmanpaşa','Güngören','Kadıköy','Kağıthane','Kartal','Küçükçekmece','Maltepe','Pendik','Sancaktepe','Sarıyer','Silivri','Sultanbeyli','Sultangazi','Şile','Şişli','Tuzla','Ümraniye','Üsküdar','Zeytinburnu'],
    'İzmir': ['Aliağa','Balçova','Bayındır','Bayraklı','Bergama','Beydağ','Bornova','Buca','Çeşme','Çiğli','Dikili','Foça','Gaziemir','Güzelbahçe','Karabağlar','Karaburun','Karşıyaka','Kemalpaşa','Kınık','Kiraz','Konak','Menderes','Menemen','Narlıdere','Ödemiş','Seferihisar','Selçuk','Tire','Torbalı','Urla'],
    'Kahramanmaraş': ['Afşin','Andırın','Çağlayancerit','Dulkadiroğlu','Ekinözü','Elbistan','Göksun','Nurhak','Onikişubat','Pazarcık','Türkoğlu'],
    'Karabük': ['Eflani','Eskipazar','Merkez','Ovacık','Safranbolu','Yenice'],
    'Karaman': ['Ayrancı','Başyayla','Ermenek','Kazımkarabekir','Merkez','Sarıveliler'],
    'Kars': ['Akyaka','Arpaçay','Digor','Kağızman','Merkez','Sarıkamış','Selim','Susuz'],
    'Kastamonu': ['Abana','Ağlı','Araç','Azdavay','Bozkurt','Cide','Çatalzeytin','Daday','Devrekani','Doğanyurt','Hanönü','İhsangazi','İnebolu','Küre','Merkez','Pınarbaşı','Seydiler','Şenpazar','Taşköprü','Tosya'],
    'Kayseri': ['Akkışla','Bünyan','Develi','Felahiye','Hacılar','İncesu','Kocasinan','Melikgazi','Özvatan','Pınarbaşı','Sarıoğlan','Sarız','Talas','Tomarza','Yahyalı','Yeşilhisar'],
    'Kırıkkale': ['Bahşılı','Balışeyh','Çelebi','Delice','Karakeçili','Keskin','Merkez','Sulakyurt','Yahşihan'],
    'Kırklareli': ['Babaeski','Demirköy','Kofçaz','Lüleburgaz','Merkez','Pehlivanköy','Pınarhisar','Vize'],
    'Kırşehir': ['Akçakent','Akpınar','Boztepe','Çiçekdağı','Kaman','Merkez','Mucur'],
    'Kilis': ['Elbeyli','Merkez','Musabeyli','Polateli'],
    'Kocaeli': ['Başiskele','Çayırova','Darıca','Derince','Dilovası','Gebze','Gölcük','İzmit','Kandıra','Karamürsel','Kartepe','Körfez'],
    'Konya': ['Ahırlı','Akören','Akşehir','Altınekin','Beyşehir','Bozkır','Cihanbeyli','Çeltik','Çumra','Derbent','Derebucak','Doğanhisar','Emirgazi','Ereğli','Güneysınır','Hadim','Halkapınar','Hüyük','Ilgın','Kadınhanı','Karapınar','Karatay','Kulu','Meram','Sarayönü','Selçuklu','Seydişehir','Taşkent','Tuzlukçu','Yalıhüyük','Yunak'],
    'Kütahya': ['Altıntaş','Aslanapa','Çavdarhisar','Domaniç','Dumlupınar','Emet','Gediz','Hisarcık','Merkez','Pazarlar','Simav','Şaphane','Tavşanlı'],
    'Malatya': ['Akçadağ','Arapgir','Arguvan','Battalgazi','Darende','Doğanşehir','Doğanyol','Hekimhan','Kale','Kuluncak','Pütürge','Yazıhan','Yeşilyurt'],
    'Manisa': ['Ahmetli','Akhisar','Alaşehir','Demirci','Gölmarmara','Gördes','Kırkağaç','Köprübaşı','Kula','Salihli','Sarıgöl','Saruhanlı','Selendi','Soma','Şehzadeler','Turgutlu','Yunusemre'],
    'Mardin': ['Artuklu','Dargeçit','Derik','Kızıltepe','Mazıdağı','Midyat','Nusaybin','Ömerli','Savur','Yeşilli'],
    'Mersin': ['Akdeniz','Anamur','Aydıncık','Bozyazı','Çamlıyayla','Erdemli','Gülnar','Mezitli','Mut','Silifke','Tarsus','Toroslar','Yenişehir'],
    'Muğla': ['Bodrum','Dalaman','Datça','Fethiye','Kavaklıdere','Köyceğiz','Marmaris','Menteşe','Milas','Ortaca','Seydikemer','Ula','Yatağan'],
    'Muş': ['Bulanık','Hasköy','Korkut','Malazgirt','Merkez','Varto'],
    'Nevşehir': ['Acıgöl','Avanos','Derinkuyu','Gülşehir','Hacıbektaş','Kozaklı','Merkez','Ürgüp'],
    'Niğde': ['Altunhisar','Bor','Çamardı','Çiftlik','Merkez','Ulukışla'],
    'Ordu': ['Akkuş','Altınordu','Aybastı','Çamaş','Çatalpınar','Çaybaşı','Fatsa','Gölköy','Gülyalı','Gürgentepe','İkizce','Kabadüz','Kabataş','Korgan','Kumru','Mesudiye','Perşembe','Ulubey','Ünye'],
    'Osmaniye': ['Bahçe','Düziçi','Hasanbeyli','Kadirli','Merkez','Sumbas','Toprakkale'],
    'Rize': ['Ardeşen','Çamlıhemşin','Çayeli','Derepazarı','Fındıklı','Güneysu','Hemşin','İkizdere','İyidere','Kalkandere','Merkez','Pazar'],
    'Sakarya': ['Adapazarı','Akyazı','Arifiye','Erenler','Ferizli','Geyve','Hendek','Karapürçek','Karasu','Kaynarca','Kocaali','Pamukova','Sapanca','Serdivan','Söğütlü','Taraklı'],
    'Samsun': ['Alaçam','Asarcık','Atakum','Ayvacık','Bafra','Canik','Çarşamba','Havza','İlkadım','Kavak','Ladik','Ondokuzmayıs','Salıpazarı','Tekkeköy','Terme','Vezirköprü','Yakakent'],
    'Siirt': ['Baykan','Eruh','Kurtalan','Merkez','Pervari','Şirvan','Tillo'],
    'Sinop': ['Ayancık','Boyabat','Dikmen','Durağan','Erfelek','Gerze','Merkez','Saraydüzü','Türkeli'],
    'Sivas': ['Akıncılar','Altınyayla','Divriği','Doğanşar','Gemerek','Gölova','Gürün','Hafik','İmranlı','Kangal','Koyulhisar','Merkez','Suşehri','Şarkışla','Ulaş','Yıldızeli','Zara'],
    'Şanlıurfa': ['Akçakale','Birecik','Bozova','Ceylanpınar','Eyyübiye','Halfeti','Haliliye','Harran','Hilvan','Karaköprü','Siverek','Suruç','Viranşehir'],
    'Şırnak': ['Beytüşşebap','Cizre','Güçlükonak','İdil','Merkez','Silopi','Uludere'],
    'Tekirdağ': ['Çerkezköy','Çorlu','Ergene','Hayrabolu','Kapaklı','Malkara','Marmaraereğlisi','Muratlı','Saray','Süleymanpaşa','Şarköy'],
    'Tokat': ['Almus','Artova','Başçiftlik','Erbaa','Merkez','Niksar','Pazar','Reşadiye','Sulusaray','Turhal','Yeşilyurt','Zile'],
    'Trabzon': ['Akçaabat','Araklı','Arsin','Beşikdüzü','Çarşıbaşı','Çaykara','Dernekpazarı','Düzköy','Hayrat','Köprübaşı','Maçka','Of','Ortahisar','Sürmene','Şalpazarı','Tonya','Vakfıkebir','Yomra'],
    'Tunceli': ['Çemişgezek','Hozat','Mazgirt','Merkez','Nazımiye','Ovacık','Pertek','Pülümür'],
    'Uşak': ['Banaz','Eşme','Karahallı','Merkez','Sivaslı','Ulubey'],
    'Van': ['Bahçesaray','Başkale','Çaldıran','Çatak','Edremit','Erciş','Gevaş','Gürpınar','İpekyolu','Muradiye','Özalp','Saray','Tuşba'],
    'Yalova': ['Altınova','Armutlu','Çınarcık','Çiftlikköy','Merkez','Termal'],
    'Yozgat': ['Akdağmadeni','Aydıncık','Boğazlıyan','Çandır','Çayıralan','Çekerek','Kadışehri','Merkez','Saraykent','Sarıkaya','Sorgun','Şefaatli','Yenifakılı','Yerköy'],
    'Zonguldak': ['Alaplı','Çaycuma','Devrek','Ereğli','Gökçebey','Kilimli','Kozlu','Merkez']
  };

  // ---- yardımcılar ----
  function el(tag, attrs) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) { if (k === 'text') e.textContent = attrs[k]; else e.setAttribute(k, attrs[k]); }
    return e;
  }
  function loadSaved() { try { return JSON.parse(localStorage.getItem(LS_KEY)) || {}; } catch (e) { return {}; } }
  function save(state) { try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (e) {} }

  function injectCSS() {
    if (document.getElementById('ca-style')) return;
    var css = ''
      + '.cart-address{margin:16px 0;padding:16px;border:1px solid rgb(var(--color-foreground)/0.12);border-radius:8px;background:rgb(var(--color-foreground)/0.04)}'
      + '.cart-address__title{font-weight:600;margin-bottom:12px;font-size:15px}'
      + '.cart-address__field{margin-bottom:10px}'
      + '.cart-address__field[hidden]{display:none}'
      + '.cart-address__label{display:block;font-size:12px;opacity:.6;margin-bottom:4px}'
      + '.cart-address__select{width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid rgb(var(--color-foreground)/0.25);border-radius:6px;background:rgb(var(--color-background));font-size:14px;color:rgb(var(--color-foreground))}'
      + "select.cart-address__select{-webkit-appearance:none;appearance:none;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23888' d='M6 8L0 0h12z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right 12px center;padding-right:32px}"
      + '.cart-address__select:disabled{background-color:rgb(var(--color-foreground)/0.06);opacity:.5;cursor:not-allowed}'
      + '.cart-address__error{color:#c0392b;font-size:13px;margin:8px 0 0}'
      + '.cart-address__error[hidden]{display:none}';
    var s = el('style', { id: 'ca-style' });
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  // ---- Bölge→şehir veri dosyasını tembel yükle ----
  var dataState = 'idle'; // idle | loading | ready | failed
  var dataWaiters = [];
  function dataObj() { return window.__CA_DATA || null; }
  function ensureData(cb) {
    if (dataObj()) { dataState = 'ready'; cb(); return; }
    if (cb) dataWaiters.push(cb);
    if (dataState === 'loading') return;
    var src = null;
    var any = document.querySelector('[data-cart-address][data-ca-src]');
    if (any) src = any.getAttribute('data-ca-src');
    if (!src) { dataState = 'failed'; flushWaiters(); return; }
    dataState = 'loading';
    var s = el('script', { src: src });
    s.onload = function () { dataState = dataObj() ? 'ready' : 'failed'; flushWaiters(); };
    s.onerror = function () { dataState = 'failed'; flushWaiters(); };
    document.head.appendChild(s);
  }
  function flushWaiters() {
    var w = dataWaiters.slice(); dataWaiters.length = 0;
    w.forEach(function (f) { try { f(); } catch (e) {} });
  }

  // Ülkenin bölge listesi: [[değer, etiket], ...] veya null (veri henüz yok)
  function divisionsFor(cc) {
    if (cc === 'TR') return Object.keys(TR).map(function (k) { return [k, k]; });
    var d = dataObj();
    if (!d) return null;
    if (PROV_CC[cc] && d.prov[cc]) return d.prov[cc];
    if (d.cities[cc]) return Object.keys(d.cities[cc]).map(function (k) { return [k, k]; });
    return [];
  }
  // Bölgenin şehir listesi: ['Şehir',...] | null (yalnızca veri henüz yüklenmediyse)
  function citiesFor(cc, div) {
    if (cc === 'TR') return TR[div] || null;
    var d = dataObj();
    if (!d) return null;
    var list = d.cities[cc] && d.cities[cc][div];
    if (list && list.length) return list;
    return div ? [div] : null; // liste yoksa bölge adı şehir olarak sunulur
  }

  function fillSelect(sel, pairs, placeholder) {
    sel.innerHTML = '';
    sel.appendChild(el('option', { value: '', text: placeholder }));
    (pairs || []).forEach(function (p) {
      sel.appendChild(el('option', { value: p[0], text: p[1] }));
    });
  }

  var roots = [];

  function initRoot(root) {
    var country = root.querySelector('.ca-country');
    var province = root.querySelector('.ca-province');
    var district = root.querySelector('.ca-district');
    var fProv = root.querySelector('.ca-f-province');
    var fDist = root.querySelector('.ca-f-district');
    var errorEl = root.querySelector('.ca-error');
    var lblProv = fProv.querySelector('.cart-address__label');
    var lblDist = fDist.querySelector('.cart-address__label');

    // Ülke seçenekleri
    country.appendChild(el('option', { value: '', text: IS_EN ? 'Select country' : 'Ülke seçin' }));
    COUNTRIES.forEach(function (c) { country.appendChild(el('option', { value: c.code, text: countryDisplayName(c) })); });

    function labels() {
      var cc = country.value;
      if (IS_EN) {
        if (cc === 'TR') { lblProv.textContent = 'Province'; lblDist.textContent = 'District'; }
        else if (PROV_CC[cc]) { lblProv.textContent = 'State / Region'; lblDist.textContent = 'City'; }
        else { lblProv.textContent = 'Region'; lblDist.textContent = 'City'; }
        return;
      }
      if (cc === 'TR') { lblProv.textContent = 'İl'; lblDist.textContent = 'İlçe'; }
      else if (PROV_CC[cc]) { lblProv.textContent = 'Eyalet / Bölge'; lblDist.textContent = 'Şehir'; }
      else { lblProv.textContent = 'Bölge'; lblDist.textContent = 'Şehir'; }
    }

    // Bölge dropdown'ını doldur (veri hazırsa); resetSub=true → alt seçimler sıfırlanır
    function applyCountryUI(resetSub) {
      var cc = country.value;
      labels();
      if (!cc) { fProv.hidden = true; fDist.hidden = true; return; }
      var divs = divisionsFor(cc);
      if (divs === null || !divs.length) {
        // veri yükleniyor (ya da beklenmedik şekilde yok) → gelince yeniden kur
        fProv.hidden = false; fDist.hidden = true;
        fillSelect(province, [], IS_EN ? 'Loading…' : 'Yükleniyor…');
        province.disabled = true;
        ensureData(function () { applyCountryUI(resetSub); restoreSub(); });
        return;
      }
      fProv.hidden = false;
      fillSelect(province, divs, IS_EN ? ('Select ' + lblProv.textContent.toLowerCase()) : (lblProv.textContent + ' seçin'));
      province.disabled = false;
      if (resetSub) { district.innerHTML = ''; fDist.hidden = true; }
      applyCityUI();
    }

    // Şehir alanı: her zaman dropdown (elle yazma yok)
    function applyCityUI() {
      var cc = country.value;
      var div = province.value;
      fDist.hidden = true;
      if (!div) return;
      var cities = citiesFor(cc, div);
      if (!cities) return; // yalnızca veri yüklenirken; hazır olunca yeniden kurulur
      fDist.hidden = false;
      var keep = district.value;
      fillSelect(district, cities.map(function (c) { return [c, c]; }), IS_EN ? ('Select ' + lblDist.textContent.toLowerCase()) : (lblDist.textContent + ' seçin'));
      if (keep) district.value = keep;
      district.disabled = false;
    }

    function hideErr() { if (errorEl) errorEl.hidden = true; }
    function showErr(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Seçilen şehir değeri (her zaman dropdown'dan)
    function cityValue() {
      if (!province.value) return '';
      return district.value || '';
    }

    function persist() {
      save({ country: country.value, province: province.value, district: district.value });
      syncOthers(api);
    }

    function restoreSub() {
      var s = loadSaved();
      if (s.province) {
        // kayıtlı bölge güncel listede varsa geri yükle
        var opts = Array.prototype.map.call(province.options, function (o) { return o.value; });
        if (opts.indexOf(s.province) !== -1) {
          province.value = s.province;
          applyCityUI();
          if (s.district) {
            var dopts = Array.prototype.map.call(district.options, function (o) { return o.value; });
            if (dopts.indexOf(s.district) !== -1) district.value = s.district;
          }
        }
      }
    }

    function restore() {
      var s = loadSaved();
      country.value = (s.country != null && s.country !== '') ? s.country : 'TR';
      if (!country.value) country.value = 'TR';
      applyCountryUI(false);
      restoreSub();
    }

    country.addEventListener('change', function () { applyCountryUI(true); hideErr(); persist(); });
    // ülke listesine dokunulduğunda veriyi önceden ısıt (dropdown beklemesin)
    country.addEventListener('pointerdown', function () { ensureData(function () {}); });
    country.addEventListener('focus', function () { ensureData(function () {}); });
    province.addEventListener('change', function () { district.value = ''; applyCityUI(); hideErr(); persist(); });
    district.addEventListener('change', function () { hideErr(); persist(); });

    var api = {
      root: root, country: country, province: province, district: district,
      showErr: showErr, hideErr: hideErr,
      cityValue: cityValue, restore: restore
    };
    roots.push(api);

    restore();
  }

  function syncOthers(changed) {
    roots.forEach(function (a) { if (a !== changed) a.restore(); });
  }

  // Tıklanan butona en yakın GÖRÜNÜR seçici örneği (sepet sayfası ↔ çekmece)
  function activeRoot() {
    var vis = roots.filter(function (a) { return a.root.offsetParent !== null; });
    return vis[0] || roots[0] || null;
  }

  // Document-düzeyi delegasyon: buton formu yeniden render edilse de çalışır.
  function bindCheckoutDelegation() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest('[name="checkout"]');
      if (!btn || btn.disabled) return;
      var api = activeRoot();
      if (!api) return;
      if (!api.country.value) { ev.preventDefault(); ev.stopImmediatePropagation(); api.showErr(IS_EN ? 'Please select a country.' : 'Lütfen ülke seçin.'); return; }
      if (!api.province.value && api.province.parentElement && !api.province.parentElement.hidden) {
        ev.preventDefault(); ev.stopImmediatePropagation(); api.showErr(IS_EN ? 'Please select a region/province.' : 'Lütfen bölge/il seçin.'); return;
      }
      if (!api.cityValue()) {
        ev.preventDefault(); ev.stopImmediatePropagation();
        api.showErr(api.country.value === 'TR'
          ? (IS_EN ? 'Please select province and district.' : 'Lütfen İl ve İlçe seçin.')
          : (IS_EN ? 'Please select a city.' : 'Lütfen şehir seçin.'));
        return;
      }
      ev.preventDefault(); ev.stopImmediatePropagation();
      goToCheckout(api, btn);
    }, true); // capture: tema doğrulamalarından önce
  }

  function goToCheckout(api, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    var cc = api.country.value;
    var div = api.province.value;
    var city = api.cityValue();
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { window.location.href = '/checkout'; return; }
        var complex = cart.items.some(function (it) {
          return (it.properties && Object.keys(it.properties).length) || it.selling_plan_allocation;
        });
        if (complex || (cart.total_discount && cart.total_discount > 0)) { window.location.href = '/checkout'; return; }
        var lines = cart.items.map(function (it) { return it.variant_id + ':' + it.quantity; }).join(',');
        var params = ['checkout[shipping_address][country]=' + encodeURIComponent(cc)];
        if (cc === 'TR') {
          params.push('checkout[shipping_address][city]=' + encodeURIComponent(div));
          if (city) params.push('checkout[shipping_address][address2]=' + encodeURIComponent(city));
        } else if (PROV_CC[cc]) {
          if (div) params.push('checkout[shipping_address][province]=' + encodeURIComponent(div));
          if (city) params.push('checkout[shipping_address][city]=' + encodeURIComponent(city));
        } else {
          if (city) params.push('checkout[shipping_address][city]=' + encodeURIComponent(city));
          if (div) params.push('checkout[shipping_address][address2]=' + encodeURIComponent(div));
        }
        window.location.href = '/cart/' + lines + '?' + params.join('&');
      })
      .catch(function () { window.location.href = '/checkout'; });
  }

  var delegationBound = false;
  function init() {
    var found = document.querySelectorAll('[data-cart-address]');
    if (!found.length) return;
    injectCSS();
    if (!delegationBound) { delegationBound = true; bindCheckoutDelegation(); }
    Array.prototype.forEach.call(found, function (root) {
      if (root.getAttribute('data-ca-init')) return;
      root.setAttribute('data-ca-init', '1');
      initRoot(root);
    });
    // sepet sayfasındaysak veriyi hemen ısıt; kayıtlı ülke TR değilse de gerekir
    var saved = loadSaved();
    if (document.body && (document.body.classList.contains('template-cart') || location.pathname === '/cart' || (saved.country && saved.country !== 'TR'))) {
      ensureData(function () { roots.forEach(function (a) { a.restore(); }); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
